<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <div style="float: right">
        <md-button class="md-success" :disabled="isDisabled" @click="GetUnallocatedDevices()">
          Refresh<span v-if="isDisabled"><i class="fa fa-spinner fa-spin"></i></span>
        </md-button>
      </div>
      <md-card>
        <md-card-header>
          <h4 class="title">Unallocated Apple Business Manager Devices</h4>
          <p class="category">Devices registered in ABM with no MDM profile assigned</p>
        </md-card-header>
        <md-card-content>
          <div class="md-layout">
            <div class="md-layout-item md-size-33">
              <md-field>
                <md-input type="text" class="box-textbox" placeholder="Serial Number" v-model="search_serial_number"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-33">
              <md-field>
                <md-input type="text" class="box-textbox" placeholder="Model" v-model="search_model"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-33">
              <md-field>
                <md-select class="box-textbox" placeholder="Profile Status" v-model="search_profile_status">
                  <md-option value="all">All</md-option>
                  <md-option value="empty">Empty (Unallocated)</md-option>
                  <md-option value="assigned">Assigned</md-option>
                  <md-option value="pushed">Pushed</md-option>
                  <md-option value="removed">Removed</md-option>
                </md-select>
              </md-field>
            </div>
          </div>
          <hr>

          <div v-if="isDisabled" class="text-center py-4">
            <i class="fa fa-spinner fa-spin fa-2x"></i>
          </div>

          <div v-else-if="statusFilteredData.length === 0" class="text-center py-4">
            <p class="card-category">No ABM devices found for this filter.</p>
          </div>

          <md-table
            v-else
            :value="queriedData"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="customSort"
            class="md-container-custom paginated-table" table-header-color="green" md-fixed-header>
            <md-table-toolbar>
              <md-field>
                <label for="pages">Per page</label>
                <md-select v-model="pagination.perPage" name="pages">
                  <md-option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
                    {{ item }}
                  </md-option>
                </md-select>
              </md-field>
            </md-table-toolbar>
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Serial Number" md-sort-by="serial_number">
                {{ item.serial_number }}
              </md-table-cell>
              <md-table-cell md-label="Description">
                {{ item.description }}
                <p class="badge-red">{{ item.os }}</p>
              </md-table-cell>
              <md-table-cell md-label="Model" md-sort-by="model">{{ item.model }}</md-table-cell>
              <md-table-cell md-label="Color">{{ item.color }}</md-table-cell>
              <md-table-cell md-label="Assigned By / Date" md-sort-by="device_assigned_date">
                {{ item.device_assigned_by }}
                <br>
                <small>{{ HumanReadableDateFormat(item.device_assigned_date) }}</small>
              </md-table-cell>
              <md-table-cell md-label="Profile Status" md-sort-by="profile_status">
                <p class="status-pill" :class="profileStatusBadgeClass(item.profile_status)">{{ item.profile_status || 'empty' }}</p>
                <small v-if="item.profile_uuid">
                  UUID: {{ item.profile_uuid }}<br>
                  Assigned: {{ HumanReadableDateFormat(item.profile_assign_time) }}
                </small>
              </md-table-cell>
              <md-table-cell md-label="Actions">
                <md-button
                    v-if="item.profile_status === 'empty'"
                    class="md-just-icon md-success md-simple"
                    style="margin: unset;"
                    @click="openAssignProfileModal(item)">
                    <md-tooltip md-direction="top">Assign Profile</md-tooltip>
                    <md-icon>assignment_ind</md-icon>
                </md-button>
                <span v-else>-</span>
                </md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
        <md-card-actions md-alignment="space-between" v-if="tableData.length > 0">
          <div class="">
            <p class="card-category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <pagination
            class="pagination-no-border pagination-success"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          >
          </pagination>
        </md-card-actions>
      </md-card>

      <!-- Assign Profile Modal -->
      <template>
        <modal v-if="assignProfileModal" @close="closeAssignProfileModal()">
          <template slot="header">
            <h4 class="modal-title">Assign ABM Profile</h4>
            <md-button
              style="height: 25px" class="md-simple md-just-icon md-round modal-default-button"
              @click="closeAssignProfileModal()"><md-icon>clear</md-icon></md-button>
          </template>
          <template slot="body">
            <div class="box-body">
                <div class="md-layout" v-if="assign_device">
                <div class="md-layout-item md-size-100 device-detail-box">
                    <p><b>Serial Number:</b> {{ assign_device.serial_number }}</p>
                    <p><b>Description:</b> {{ assign_device.description }}</p>
                    <p><b>Model:</b> {{ assign_device.model }} &nbsp; <b>Color:</b> {{ assign_device.color }}</p>
                    <p><b>OS:</b> {{ assign_device.os }}</p>
                </div>
                </div>
                <hr>
                <div class="md-layout">
                <div class="md-layout-item md-size-100">
                    <md-field>
                    <select style="width: 100%;border: unset;" v-model="assign_profile_id">
                        <option value="">Select Profile</option>
                        <option v-for="profile in iosProfiles" v-bind:key="profile._id" :value="profile._id">
                        {{ profile.profile_name }}
                        </option>
                    </select>
                    </md-field>
                </div>
                </div>
                <div class="md-layout">
                <div class="md-layout-item md-size-100">
                    <md-field>
                    <label>Support Phone</label>
                    <md-input type="text" v-model="assign_support_phone"></md-input>
                    </md-field>
                </div>
                </div>
                <div class="md-layout">
                <div class="md-layout-item md-size-100">
                    <md-field>
                    <label>Support Email</label>
                    <md-input type="email" v-model="assign_support_email"></md-input>
                    </md-field>
                </div>
                </div>
            </div>
            </template>
          <template slot="footer">
            <md-button class="md-danger md-simple" @click="closeAssignProfileModal()">Close</md-button>
            <md-button class="md-success" type="submit" :disabled="isAssigning" @click="AssignProfile()">
              Assign<span v-if="isAssigning"><i class="fa fa-spinner fa-spin"></i></span>
            </md-button>
          </template>
        </modal>
      </template>
    </div>
  </div>
</template>
<script>
import IosAppleBusinessManagerDataService from "../../services/IosAppleBusinessManagerDataService";
import DeviceProceDataService from "../../services/DeviceProceDataService";
import { Pagination } from "@/components";
import { Modal } from "@/components";

export default {
  components: {
    Pagination,
    Modal,
  },
  computed: {
    statusFilteredData() {
      let result = this.tableData;
      if (this.search_profile_status !== "all") {
        result = result.filter((d) => {
          if (this.search_profile_status === "empty") {
            return !d.profile_status || d.profile_status === "empty";
          }
          return d.profile_status === this.search_profile_status;
        });
      }
      if (this.search_serial_number) {
        result = result.filter((d) =>
          (d.serial_number || "").toLowerCase().includes(this.search_serial_number.toLowerCase())
        );
      }
      if (this.search_model) {
        result = result.filter((d) =>
          (d.model || "").toLowerCase().includes(this.search_model.toLowerCase())
        );
      }
      return result;
    },
    queriedData() {
      return this.statusFilteredData.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.statusFilteredData.length;
    },
  },
  data() {
    return {
      isDisabled: false,
      isAssigning: false,
      tableData: [],
      search_serial_number: "",
      search_model: "",
      search_profile_status: "empty",
      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50, 100, 200, 500],
        total: 0,
      },
      currentSort: "serial_number",
      currentSortOrder: "asc",

      // Assign Profile modal
      assignProfileModal: false,
      assign_device: null,
      assign_profile_id: "",
      assign_support_phone: "",
      assign_support_email: "",
      iosProfiles: [],
    };
  },
  methods: {
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder === "desc") {
          return (a[sortBy] || "").localeCompare(b[sortBy] || "");
        }
        return (b[sortBy] || "").localeCompare(a[sortBy] || "");
      });
    },
    HumanReadableDateFormat(date) {
      if (!date) return "-";
      return new Date(date).toLocaleString();
    },
    profileStatusBadgeClass(status) {
      if (status === "pushed") return "status-pushed";
      if (status === "assigned") return "status-assigned";
      if (status === "removed") return "status-removed";
      return "status-empty"; // empty / unknown
    },
    GetUnallocatedDevices() {
      this.isDisabled = true;
      IosAppleBusinessManagerDataService.getUnallocatedABMDevices()
        .then((response) => {
          this.isDisabled = false;
          this.tableData = response.data.data.devices || [];
        })
        .catch((e) => {
          this.isDisabled = false;
          if (e.response) {
            this.$toast.error(e.response.data.response_msg);
          }
        });
    },
    getIosProfiles() {
      DeviceProceDataService.GetDeviceProfileList({ search_profile_type: "Ios" })
        .then((response) => {
          if (response.data.data) {
            this.iosProfiles = response.data.data;
          }
        })
        .catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    openAssignProfileModal(device) {
        this.assign_device = device;
        this.assign_profile_id = "";
        this.assign_support_phone = "";
        this.assign_support_email = "";
        this.assignProfileModal = true;
    },
    closeAssignProfileModal() {
        this.assignProfileModal = false;
        this.assign_device = null;
    },

    AssignProfile() {
    if (!this.assign_profile_id) {
      this.$toast.error("Please select a profile.");
      return;
    }
    if (!this.assign_support_phone) {
      this.$toast.error("Please enter support phone.");
      return;
    }
    if (!this.assign_support_email) {
      this.$toast.error("Please enter support email.");
      return;
    }

    this.isAssigning = true;
    let data = {
      serial_numbers: [this.assign_device.serial_number],
      profile_id: this.assign_profile_id,
      support_phone: this.assign_support_phone,
      support_email: this.assign_support_email,
    };
    IosAppleBusinessManagerDataService.assignDevicesToProfile(data)
      .then((response) => {
        this.isAssigning = false;
        this.$toast.success(response.data.response_msg);
        this.closeAssignProfileModal();
        this.GetUnallocatedDevices();
      })
      .catch((e) => {
        this.isAssigning = false;
        if (e.response) {
          this.$toast.error(e.response.data.response_msg);
        }
      });
  },
  },
  watch: {
    // Reset to page 1 whenever a filter changes so the user doesn't land on an empty page
    search_serial_number() {
      this.pagination.currentPage = 1;
    },
    search_model() {
      this.pagination.currentPage = 1;
    },
    search_profile_status() {
      this.pagination.currentPage = 1;
    },
  },
  beforeMount() {
    this.GetUnallocatedDevices();
    this.getIosProfiles();
  },
};
</script>

<style scoped>
.actions-cell {
  overflow: visible !important;
  white-space: nowrap !important;
  min-width: 60px;
}
.assign-btn {
  min-width: unset !important;
  width: 36px;
  height: 36px;
  padding: 0 !important;
}
.device-detail-box {
  background: #f7f7f7;
  border-radius: 6px;
  padding: 10px 15px;
  margin-bottom: 10px;
}
.device-detail-box p {
  margin: 4px 0;
}
.status-pill {
  display: inline-block;
  width: auto;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  color: #fff;
  margin: 0 0 4px 0;
  line-height: 1.4;
}
.status-empty {
  background-color: #ff9800;
}
.status-assigned {
  background-color: #9c27b0;
}
.status-pushed {
  background-color: #4caf50;
}
.status-removed {
  background-color: #f44336;
}
</style>